// Tüm Siparişler sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.allOrders';

export const allOrdersGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Tüm Siparişler nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Telefon, QR, Kiosk, E-Ticaret ve yemek platformlarından gelen tüm siparişleri tek listede, en yeni en üstte görürsünüz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve Excel'),
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    filters: t(`${G}.regions.filters`, 'Arama ve filtreler'),
    table: t(`${G}.regions.table`, 'Sipariş listesi'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Özet kartlarını okuyun'),
      text: t(`${G}.s1.text`, '"Toplam Sipariş" filtrelerinize uyan tüm siparişlerin sayısıdır. Diğer kartlar yalnız ekrandaki sayfaya bakar.'),
      tips: [
        t(`${G}.s1.tip1`, 'Sayfadaki Sipariş: bu sayfada listelenen sipariş sayısı.'),
        t(`${G}.s1.tip2`, 'İptal Siparişler: bu sayfadaki iptal sipariş sayısı.'),
        t(`${G}.s1.tip3`, 'Sayfa Toplam Tutar: bu sayfadaki siparişlerin tutar toplamı; iptal siparişler de bu toplama dahildir.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Tarih, şube ve kaynağa göre süzün'),
      text: t(`${G}.s2.text`, 'Arama kutusuna müşteri adı veya sipariş no yazın. Şube, Platform (Telefon, QR Sipariş, Kiosk, E-Ticaret, Getir, Migros, Yemeksepeti, Uber Eats) ve Başlangıç / Bitiş tarihleriyle listeyi daraltın. "Temizle" filtreleri sıfırlar.'),
      tips: [
        t(`${G}.s2.tip1`, 'Şube yöneticisi olarak girdiyseniz şube filtresi kendi şubenize kilitlidir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Kaynağı ve durumu okuyun'),
      text: t(`${G}.s3.text`, 'Platform sütunu siparişin nereden geldiğini, Durum sütunu nerede olduğunu gösterir: Yeni, Kabul Edildi, Hazırlanıyor, Yolda, Teslim Edildi, Tamamlandı, İptal.'),
      tips: [
        t(`${G}.s3.tip1`, 'Ö. bilgisi: ödeme yöntemi. Ö. Durumu: ✓ ödendi, ₺ ödeme bekliyor.'),
        t(`${G}.s3.tip2`, 'Kurye sütunu siparişi götüren kuryeyi gösterir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Sipariş detayını açın'),
      text: t(`${G}.s4.text`, 'Satıra tıklayın ya da ⋮ menüsünden "Detaylar"ı seçin. Detay penceresinde ürünler, tutarlar ve ödeme bilgisi görünür; iptal edilmiş telefon siparişinde iptal nedeni de yazar. "Fiş Yazdır" ile fişi yeniden basabilirsiniz.'),
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. İptal ve iade nereden yapılır?'),
      text: t(`${G}.s5.text`, 'Bu sayfa yalnız görüntüleme içindir; buradan sipariş iptal edilmez, ödeme iade edilmez. İptal için ⋮ menüsündeki "Sipariş Yönetimine Git" ile paket ekranına geçin ve siparişi orada İPTAL ET / REDDET düğmesiyle işleyin.'),
    },
    {
      region: 'header',
      title: t(`${G}.s6.title`, '6. Excel\'e aktarın, sayfalar arasında gezin'),
      text: t(`${G}.s6.text`, 'Sağ üstteki Excel İndir düğmesi ekrandaki sayfanın siparişlerini dosyaya yazar. Liste uzunsa alttaki sayfalamayla ilerleyin. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
